export const ANNUAL_REPORT_TEXT_SNIPPET_FEATURE_KEY = 'aumicoAnnualReportTextSnippet';
export const ANNUAL_REPORT_AR_TEMPLATES_FEATURE_KEY = 'aumicoAnnualReportArTemplates';
export const ANNUAL_REPORT_FEATURE_KEY = 'aumicoAnnualReportMicroservice';
